import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../../../../packages/common/src/app/reducerPaths";
import { baseQueryWithAuth } from "../../../../../packages/common/src/toolkit/methods/baseQueryWithAuth";
import { VITE_NODE_SERVER_BASE_URL } from "@common/utils/constants/urls/baseUrls";

export const appConfigurationApi = createApi({
  reducerPath: reducerPaths.appConfigurationApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    fetchAppConfiguration: builder.query({
      query: () => {
        return {
          url: `${VITE_NODE_SERVER_BASE_URL}/appConfiguration`,
          method: "GET"
        }
      },
    }),
    logPageVisit: builder.mutation({
      query: ({ payload }) => {
        return {
          url: `/log-page-visit`,
          method: "POST",
          body: payload
        }
      }
    })
  }),
});

export const {
  useLazyFetchAppConfigurationQuery,
  useLogPageVisitMutation
} = appConfigurationApi;